export const professionals = [
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        img: "/images/newLanding/realtorsImg.png",
        route: "/realtors",
        title: "Realtors®",
        body: "A complete broker suite to source and market commercial opportunities. You’ll love Zonado!"
    },
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        img: "/images/newLanding/businessOwnersImg.png",
        route: "/business-owners",
        title: "Business Owners",
        body: "List your business for sale in a focused marketplace - generate the right attention.",
    },
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        img: "/images/newLanding/propertyOwner.png",
        route: "/property-owners",
        title: "Property Owners",
        body: "List your space for sale/lease where the right people are looking. Interact directly with buyers and agents.",
    },
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        img: "/images/newLanding/businessBroker.png",
        route: "/business-broker",
        title: "Business Brokers",
        body: "A complete broker suite to source and market commercial opportunities. You’ll love Zonado!",
    },
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        img: "/images/newLanding/franchise.png",
        route: "/franchisors",
        title: "Franchisors",
        body: "Grow your business with the right team. Reach them by posting your franchise on Zonado.",
    },
    {
        id: `${String(Math.random()).replace(".", "_")}`,
        img: "/images/newLanding/investorsImg.png",
        route: "/investors-buyers",
        title: "Investors/ Buyers",
        body: "Finally a platform that brings all the right opportunities together so you can find what’s best for you.",
    }
]